import { render, staticRenderFns } from "./MetricsToggle.vue?vue&type=template&id=851d4aba&scoped=true&"
import script from "./MetricsToggle.vue?vue&type=script&lang=ts&"
export * from "./MetricsToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851d4aba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
